import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { dateDiffInDays } from "../../../core/utils/generic-utils";

@Component({
    selector: 'app-range-time-picker',
    templateUrl: './range-time-picker.component.html',
    styleUrls: ['./range-time-picker.component.scss'],
    standalone: false
})
export class RangeTimePickerComponent implements OnInit {

  @Output() rangeDate: EventEmitter<any> = new EventEmitter<any>();
  @Output() dateChanged: EventEmitter<any> = new EventEmitter<any>()

  @Input() startDaysOffset: number = 6;

  constructor(private _snackBar: MatSnackBar) { }

  allowFetch: boolean = true;
  defaultStartDate: Date;
  defaultEndDate: Date;
  startDate: Date;
  endDate: Date;
  startMaxDate: Date;
  startMinDate: Date;
  endMaxDate: Date;
  endMinDate: Date;
  endErrorMessage: string;

  processDateDiff(){
    const dateDiff = dateDiffInDays(this.startDate, this.endDate);
    this.allowFetch = dateDiff >= 0 && dateDiff <= 31;
    if (dateDiff < 0) {
      this.endErrorMessage = "Please select a Start Date prior to the End Date"
    }
    if (dateDiff > 31) {
      this.endErrorMessage = "Please select an End Date no further than 31 days after the set Start Date"
    }
  }

  startDateEvent(event: MatDatepickerInputEvent<Date>) {
    this.dateChanged.emit(true);
    this.startDate = new Date(event.value);
    this.endMinDate = this.startDate;
    const nextMonth = new Date(this.startDate);
    nextMonth.setMonth(this.startDate.getMonth() + 1);
    this.endMaxDate = nextMonth < new Date() ? nextMonth : new Date();
    this.processDateDiff();
  }

  endDateEvent(event: MatDatepickerInputEvent<Date>) {
    this.dateChanged.emit(true);
    this.endDate = new Date(event.value);
    const nextMonth = new Date(this.startDate);
    nextMonth.setMonth(this.startDate.getMonth() + 1);
    this.endMaxDate = nextMonth < new Date() ? nextMonth : new Date();
    this.processDateDiff();
  }

  sendRangeDate(){
    this.rangeDate.emit({
      startDate: this.startDate.toISOString(),
      endDate: this.endDate.toISOString()
    });
  }


  ngOnInit(): void {
    this.defaultEndDate = new Date();
    this.defaultStartDate = new Date();
    this.defaultStartDate.setDate(this.defaultStartDate.getDate() - this.startDaysOffset);

    this.startDate = this.defaultStartDate;
    this.endDate = this.defaultEndDate;

    this.startMaxDate = new Date();
    this.endMaxDate = new Date();
    this.endMinDate = this.startDate;

    this.sendRangeDate();
  }
}
